import { render, staticRenderFns } from "./chihengfenlei.vue?vue&type=template&id=0b6a18ce&"
import script from "./chihengfenlei.vue?vue&type=script&lang=ts&"
export * from "./chihengfenlei.vue?vue&type=script&lang=ts&"
import style0 from "./chihengfenlei.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports